import React from 'react';
import { getLocale } from 'umi';
import classNames from 'classnames';
import TextBubbles from '@/pages/home/components/TextBubbles';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';
import { dynamicString } from '@home/utils/dynamicString';
import { IFunnelCard } from './types';
import './index.scss';

const FunnelCard = (props: IFunnelCard) => {
  const { dataSource, columns, bubbleColumns, bubbleTitleEn, bubbleTitleCn, bgColorList, isOneColor, isDataIndex, renderBubble } = props || {};
  const isEn = getLocale() === LANGUAGE_EN;

  // 鼠标移入背景条显示浮窗
  const renderBubbleDom = (params: any) => {
    if (typeof renderBubble === 'function') return renderBubble?.(params);
    const bubbleTitle = getLanguage(isEn, dynamicString(bubbleTitleEn, params), dynamicString(bubbleTitleCn, params));
    const bubbleDom = <div className="funnel-context-bubble">
      <div className="bubble-title">{bubbleTitle}</div>
      {
        bubbleColumns?.map((item: any) => {
          const { key, header, dataKey } = item || {};
          return <div key={key} className="bubble-flex">
            <div className="bubble-text">{header}</div>
            <div className="bubble-num">{params?.[dataKey]}</div>
          </div>;
        })
      }
    </div>;
    return bubbleDom;
  };

  return <div className="dbd-funnel-context">
    {/* 头部标题区域 */}
    <div className="funnel-context-tr">{columns?.map((item: any) => <div key={item?.key} className="funnel-context-th">{item?.header}</div>)}</div>
    {dataSource?.map((item: any, index: number) => (
      // 漏斗数据超出多少显示一种背景色
      <div key={item?.key} className={classNames("funnel-context-tr", { "funnel-other-height": isOneColor }, { "funnel-ten-height": !isOneColor })}>
        {
          columns?.map((col: any) => {
            const { key, className, dataKey, render, showBg, bgDataKey } = col || {};
            // 配置背景色,isDataIndex为true根据数据id下标匹配,false根据渲染下标匹配
            const bgColor = isDataIndex ? bgColorList?.[item?.dataIndex] : bgColorList?.[index];
            // 展示一种颜色优先级大于背景色配置
            const backgroundColor = isOneColor ? "" : bgColor;
            return render ? render?.(item) :
              // 是否最大值标红，取key值加前缀highest_字段
              <div key={key} className={classNames("funnel-context-td", className, { 'funnel-text-red funnel-text-bold': item?.[`highest_${dataKey}`] })}>
                {
                  showBg ? <>
                    <div
                      className={`funnel-bg`}
                      style={{ width: item?.[bgDataKey], backgroundColor }}
                    >
                    </div>
                    <div className='funnel-text'>{item?.[dataKey] || ""}</div>
                  </> : <TextBubbles className="text-title" text={item?.[dataKey] || ""} />
                }
              </div>;
          })
        }
        {/* 气泡 */}
        {renderBubbleDom(item)}
      </div>
    ))}
  </div>;
};

export default FunnelCard;